export default __webpack_public_path__ + "static/media/default-profile.c27eeeb4.png";